<main>
	<h1>Robbie Ferrero</h1>
	<p><a href="mailto:robbieferrero@gmail.com">email</a> <span>|</span> Principal Software Engineer <span>|</span> <a href="https://github.com/robbieferrero">github.com/robbieferrero</a></p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		/* color: #ff3e00; */
		text-transform: lowercase;
		font-size: 4em;
		font-weight: 400;
	}

	a {
		text-decoration: none;
		color: rgba(var(--base-clr));
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
	@media (max-width: 640px) {
		p > span {
			display: block;
			font-size: 0em;
			opacity: 0;
		}
	}
</style>
